document.addEventListener('DOMContentLoaded', function () {
  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.querySelectorAll('.zoom-wrapper').forEach(function (wrapper) {
    var lens = wrapper.querySelector('.zoom-lens');
    var zoomSrc = wrapper.dataset.zoomImage;

    if (!lens || !zoomSrc) return;

    // Only wire up hover-zoom on devices that actually support hover
    if (!supportsHover) return;

    wrapper.classList.add('zoom-enabled');
    lens.style.backgroundImage = 'url(' + zoomSrc + ')';

    wrapper.addEventListener('mousemove', function (event) {
      var rect = wrapper.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;

      // Clamp so lens doesn't overshoot at edges
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));

      lens.style.backgroundPosition = x + '% ' + y + '%';
    });

    wrapper.addEventListener('mouseleave', function () {
      lens.style.backgroundPosition = '50% 50%';
    });
  });
});